module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        单选\n        "), _c('vbl-select', {
    model: {
      value: (_vm.val1),
      callback: function($$v) {
        _vm.val1 = $$v
      },
      expression: "val1"
    }
  }, [_c('vbl-option', {
    attrs: {
      "value": true
    }
  }, [_vm._v("北京")]), _c('vbl-option', {
    attrs: {
      "value": false
    }
  }, [_vm._v("上海")])], 1)], 1), _vm._v("\n    " + _vm._s(_vm.val1) + "\n    "), _c('br'), _c('br'), _c('p', [_vm._v("\n        单选\n        "), _c('vbl-select', {
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_c('vbl-option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("北京")]), _c('vbl-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("上海")]), _c('vbl-option', {
    attrs: {
      "value": "2",
      "disabled": ""
    }
  }, [_vm._v("禁用")])], 1)], 1), _vm._v("\n    " + _vm._s(_vm.val) + "\n    "), _c('br'), _c('br'), _c('p', [_vm._v("\n        多选\n        "), _c('vbl-multi-select', {
    model: {
      value: (_vm.valArr),
      callback: function($$v) {
        _vm.valArr = $$v
      },
      expression: "valArr"
    }
  }, [_c('vbl-multi-option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("北京北京")]), _c('vbl-multi-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("上海上海上海")]), _c('vbl-multi-option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("广州上")]), _c('vbl-multi-option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("重庆重庆重庆重庆")]), _c('vbl-multi-option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("成")]), _c('vbl-multi-option', {
    attrs: {
      "value": "5",
      "disabled": ""
    }
  }, [_vm._v("禁用")])], 1)], 1), _vm._v("\n    " + _vm._s(_vm.valArr) + "\n    "), _c('br'), _c('br'), _c('p', [_vm._v("\n        禁用\n        "), _c('vbl-select', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.val),
      callback: function($$v) {
        _vm.val = $$v
      },
      expression: "val"
    }
  }, [_c('vbl-option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("北京")]), _c('vbl-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("上海")]), _c('vbl-option', {
    attrs: {
      "value": "2",
      "disabled": ""
    }
  }, [_vm._v("禁用")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c064a096","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblSelect/example/vblSelectExample.vue
// module id = 291
// module chunks = 0